import React from 'react';

/**
 * Balisage inline autorisé dans les textes de bloc d'un article : `**gras**` et
 * `[libellé](https://…)`. Volontairement minimal — c'est exactement ce que les
 * articles de référence utilisent, et pas davantage.
 *
 * `renderInline` rend un tableau de **nœuds React**, jamais du HTML injecté via
 * `dangerouslySetInnerHTML` : quoi que contienne le texte rédigé, il n'y a pas de
 * surface d'injection. La regex de lien n'accepte que `https://`, si bien qu'un
 * `[x](javascript:alert(1))` ne matche pas et reste affiché littéralement. C'est
 * pour cette raison que le backend ne valide pas les liens des paragraphes — à la
 * différence de l'`url` d'un bloc image, qui atterrit dans un `src`.
 */

// Deux alternatives : le gras, puis le lien. `[^*]+` impose une paire fermée, donc
// un `**` orphelin reste du texte.
const INLINE = /\*\*([^*]+)\*\*|\[([^\]\n]+)\]\((https:\/\/[^\s)]+)\)/g;

export function renderInline(texte) {
  if (!texte) return null;

  const noeuds = [];
  let dernier = 0;
  let match;

  INLINE.lastIndex = 0;
  while ((match = INLINE.exec(texte)) !== null) {
    if (match.index > dernier) noeuds.push(texte.slice(dernier, match.index));

    const [brut, gras, libelle, href] = match;
    if (gras !== undefined) {
      noeuds.push(<strong key={match.index}>{gras}</strong>);
    } else {
      noeuds.push(
        <a
          key={match.index}
          className="article-page__link"
          href={href}
          target="_blank"
          rel="noopener noreferrer"
        >
          {libelle}
        </a>
      );
    }
    dernier = match.index + brut.length;
  }

  if (dernier < texte.length) noeuds.push(texte.slice(dernier));
  return noeuds;
}

export default renderInline;
